import React from 'react';
import Layout from 'layout/Layout';
import ReservationCancelComponent from 'components/ReservationCancelComponent';

const ReservationCancelPage: React.FC = () => {
  const pageTitle = '予約のキャンセル';

  return (
    <Layout pageTitle={pageTitle}>
      <ReservationCancelComponent></ReservationCancelComponent>
    </Layout>
  );
};
export default ReservationCancelPage;
